import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ContextMenuService } from '@core/services/context-menu.service';
import { KingUser } from '@old-app/king/interfaces/king.interface';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-king-user-avatar',
  imports: [SvgIconComponent],
  templateUrl: './king-user-avatar.component.html',
  styleUrl: './king-user-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class KingUserAvatarComponent {
  public contextMenuService = inject(ContextMenuService);

  size = input<1 | 2>(1);
  kingUser = input<KingUser | null>(null);
  isChallenger = input<boolean>(false);
}
